import React from 'react';

import type * as ApiModels from '@/typings/api-models';

import HandbookCard from './HandbookCard';

type ThisProduct = Pick<ApiModels.Product, 'id' | 'isActive' | 'showOnOneLink' | 'slug' | 'title' | 'description'> & {
  handbookSteps: Array<
    Pick<ApiModels.HandbookStep, 'id'> & {
      photos: Array<Pick<ApiModels.Asset, 'mimeType'>>;
    }
  >;
  prices: Array<Pick<ApiModels.Price, 'currency' | 'isActive' | 'price'>>;
};

type ContainerProps = {
  bytes: Array<ThisProduct>;
  creatorSlug: string;
  tab: string;
};

const NewHandbookPdfContainer = ({ bytes, creatorSlug, tab }: ContainerProps): JSX.Element => (
  <>
    {bytes
      .filter((b) => b.isActive)
      .sort((a) => (a.isActive ? -1 : 1))
      .map((product) => {
        if ((product.showOnOneLink && tab === 'Services') || tab === 'Bytes') {
          return (
            <HandbookCard
              key={product.id}
              creatorSlug={creatorSlug}
              productSlug={product.slug}
              productId={product.id}
              productTitle={product.title ?? ''}
              productDescription={product.description ?? ''}
              isActive={product.isActive}
            />
          );
        }
        return null;
      })}
  </>
);

export default NewHandbookPdfContainer;
